import deepAssign from '../deep-assign';
import pipeline from '../pipeline';

let LOCALE;

function detectLocale({ locale: globalLocale }) {
	LOCALE = globalLocale;
}

function subscribe() {
	if (window && window.tesseract && window.tesseract.store) {
		const { store } = window.tesseract;

		detectLocale(store.getState());
		store.subscribe(detectLocale);
		return () => store.unsubscribe(detectLocale);
	}
}

subscribe();

function fetchOptionsPlusAcceptLanguage(opts) {
	deepAssign(opts, 'headers.Accept-Language', LOCALE || '');

	return opts;
}

const middlewares = [
	fetchOptionsPlusAcceptLanguage
];

export default pipeline(middlewares);
